import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { storage } from '@pichincha/typescript-storage';
import * as i1 from '@ngx-translate/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';

const TRANSLATE_CONFIG_STORAGE = new InjectionToken('TRANSLATE_CONFIG_STORAGE');
const TRANSLATE_CONFIG = new InjectionToken('TRANSLATE_CONFIG');

class InternationalizationService {
    constructor(config, storage_config, translate) {
        this.config = config;
        this.storage_config = storage_config;
        this.translate = translate;
    }
    /**
     * initService
     *
     */
    initService() {
        this.setLanguages();
        this.setLanguageDefault();
    }
    /**
     * setLanguageDefault
     *
     * @description Metodo para buscar en el storage si existe seteado un idioma
     * y usarlo si no, se usara por defaul el 'es'
     */
    setLanguageDefault() {
        const storage_config = this.storage_config;
        const config = this.config;
        const token = 'i18n_profile';
        let storageObject = null;
        if (config) {
            this.translate.setDefaultLang(config?.defaultLanguage ? config?.defaultLanguage : 'es');
        }
        if (storage_config) {
            storageObject = storage(storage_config);
            const lang = storageObject.get(token);
            this.translate.setDefaultLang(lang ? lang : 'es');
        }
    }
    /**
     * setLanguages
     *
     * @description Metodo para setear los idiomas disponibles, si no se setea
     * ninguno se seteara por defecto 'es'
     */
    setLanguages() {
        const config = this.config;
        this.translate.addLangs(config?.availableLanguages ? config?.availableLanguages : ['es']);
    }
    /**
     * switchLang
     *
     * @description Metodo para cambiar de idioma
     * @param lang - Idioma a usar
     */
    switchLang(lang) {
        const storageObject = storage(this.storage_config);
        storageObject.set('i18n_profile', lang);
        this.translate.use(lang);
    }
    /**
     * getLang
     *
     * @description Metodo para obtener el idioma actual
     *
     */
    getLang() {
        const storageObject = storage(this.storage_config);
        return storageObject.get('i18n_profile') || 'es';
    }
    /**
     * instantTranslate
     *
     * @description Metodo para traducir desde un componente
     *
     */
    instantTranslate(value) {
        const lang = storage(this.storage_config).get('i18n_profile') || 'es';
        this.translate.use(lang);
        return this.translate.instant(value);
    }
}
InternationalizationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: InternationalizationService, deps: [{ token: TRANSLATE_CONFIG, optional: true }, { token: TRANSLATE_CONFIG_STORAGE, optional: true }, { token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
InternationalizationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: InternationalizationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: InternationalizationService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [TRANSLATE_CONFIG]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [TRANSLATE_CONFIG_STORAGE]
                }] }, { type: i1.TranslateService }]; } });

/**
 * httpTranslateLoader
 *
 * @description Factory para realizar el llamado http hacia los archivos de traduccion
 * @param http - HttpClient de angular
 * @param injector - Injector
 */
function httpTranslateLoader(http, injector) {
    const config = injector.get(TRANSLATE_CONFIG, null);
    const url = config ? config.urlAssets : '';
    return new TranslateHttpLoader(http, url, '.json');
}
/**
  * initLocalizationService
  *
  * @description Factory para inicializar el llamado del servicio de traduccion
  */
function initLocalizationService(service) {
    return () => service.initService();
}
class InternationalizationModule {
    static forRoot() {
        return {
            ngModule: InternationalizationModule,
            providers: [
                InternationalizationService,
                {
                    provide: APP_INITIALIZER,
                    useFactory: initLocalizationService,
                    deps: [InternationalizationService],
                    multi: true
                }
            ]
        };
    }
}
InternationalizationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: InternationalizationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
InternationalizationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: InternationalizationModule, imports: [HttpClientModule, i1.TranslateModule], exports: [TranslateModule] });
InternationalizationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: InternationalizationModule, imports: [[
            HttpClientModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: httpTranslateLoader,
                    deps: [HttpClient, Injector]
                }
            })
        ], TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: InternationalizationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        HttpClientModule,
                        TranslateModule.forRoot({
                            loader: {
                                provide: TranslateLoader,
                                useFactory: httpTranslateLoader,
                                deps: [HttpClient, Injector]
                            }
                        })
                    ],
                    exports: [
                        TranslateModule
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { InternationalizationModule, InternationalizationService, TRANSLATE_CONFIG, TRANSLATE_CONFIG_STORAGE };
